import { getShopAdvancedSetting, ShopAdvancedSettingDto } from "@/services/api/shop";
import { observable, when, makeObservable, actionBound } from "mobx";

export default class ShopAdvancedSettingStore {
    constructor() {
        makeObservable(this, {
            mapping: observable,
            loadingMap: observable,
            getAdvancedSetting: actionBound,
            setAdvancedSetting: actionBound,
            ensureAdvancedSetting: actionBound,
        });
    }

    mapping = new Map<number, ShopAdvancedSettingDto>();

    loadingMap = new Map<number, boolean>();

    async getAdvancedSetting(shopId: number) {
        try {
            this.loadingMap.set(shopId, true);

            const shopAdvancedSetting = await getShopAdvancedSetting(shopId);

            this.setAdvancedSetting(shopId, shopAdvancedSetting);

            return shopAdvancedSetting;
        } finally {
            this.loadingMap.set(shopId, false);
        }
    }

    setAdvancedSetting(shopId: number, setting: ShopAdvancedSettingDto) {
        this.mapping.set(shopId, setting);
    }

    async ensureAdvancedSetting(shopId: number) {
        if (this.loadingMap.get(shopId)) {
            await when(() => !this.loadingMap.get(shopId));
        }

        if (!this.mapping.has(shopId)) {
            return await this.getAdvancedSetting(shopId);
        }

        return this.mapping.get(shopId);
    }
}
